import { render, staticRenderFns } from "./demo.vue?vue&type=template&id=24d7f261&scoped=true"
import script from "./demo.vue?vue&type=script&lang=js"
export * from "./demo.vue?vue&type=script&lang=js"
import style0 from "./demo.vue?vue&type=style&index=0&id=24d7f261&scoped=true&lang=scss"
import style1 from "./demo.vue?vue&type=style&index=1&id=24d7f261&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d7f261",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d7f261')) {
      api.createRecord('24d7f261', component.options)
    } else {
      api.reload('24d7f261', component.options)
    }
    module.hot.accept("./demo.vue?vue&type=template&id=24d7f261&scoped=true", function () {
      api.rerender('24d7f261', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/user/demo.vue"
export default component.exports